import { isNgTemplate } from '@angular/compiler';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Persona } from '../persona';

@Component({
  selector: 'app-tarjeta',
  templateUrl: './tarjeta.component.html',
  styleUrls: ['./tarjeta.component.css']
})
export class TarjetaComponent implements OnInit {
  @Input() personas: Array<Persona>;
  userData: any;
  constructor(private router:Router) { }

  ngOnInit(): void {

    this.userData = JSON.parse(localStorage.getItem('Usuario'));


  }

  async removePerson(personDel: Persona) {
    this.personas.splice(this.personas.indexOf(personDel), 1);
    if (this.personas.length == 1) {
      this.personas[0].seleccionado = true;
    }
    else if (this.personas.length > 1) {
      let _existeSel: boolean = false;;
      await this.personas.forEach(function (v) {
        if (v.seleccionado) {
          _existeSel = true;
        }
      });
      if (!_existeSel) {
        this.personas[0].seleccionado = true;
      }
    }
  }

  onCheckboxChange(e: any) {
    var id;
    if (e.target.checked) {
      id = parseInt(e.target.id.substring(e.target.id.length - 1, e.target.id.length));
      this.establecerPrincipal();
      this.personas[id].seleccionado = true;
    }

  }
  establecerPrincipal() {
    this.personas.forEach(function (v) {
      v.seleccionado = false;
    });

  }

  imprimirTicket(id: string) {
    console.log(id);
    const queryParams = {
      id: id,
    };
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/print-ticket'], {
        queryParams: queryParams,
      })
    );

    window.open(url, '_self');

  }

}
